const navBar = {
  collapse: "Collapse",
  moduleDetails: {
    homeLabel: "Home",
    userManagementLabel: "User Management",
    privacyNoticeLabel: "Privacy Notice",
    caseListLabel: "Case List",
    caseLabel: "Case Detail",
    caseSubModuleDetails: {
      summaryLabel: "Summary",
      debtorLabel: "Debtors",
      creditorLabel: "Creditors",
      claimLabel: "Claims",
      configurationLabel: "Configuration",
      distributionLabel: "Distributions",
      votingLabel: "Voting",
      importLabel: "Import History",
      portalLabel: "Portal Configuration",
      paymentLabel: "Payment Status",
      reportingLabel: "Reporting",
      taskLabel: "Tasks",
      submissionManagementLabel: "Submission Management",
    },
  },
};

export default navBar;
